var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CRM_copy_2",
    "data-name": "CRM copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.025,26.015a9.737,9.737,0,0,1,11.527,3.542"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.453,
    cy: 19.453,
    r: 5.016
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3_copy",
    "data-name": "Ellipse 3 copy",
    className: "cls-3",
    d: "M35.338,22.312a4.952,4.952,0,0,1-.9-2.852,5.02,5.02,0,0,1,10.041,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CRM_copy",
    "data-name": "CRM copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.477,42.514a16.523,16.523,0,0,1,33.045,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 20,
    cy: 16,
    r: 8.531
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3_copy-2",
    "data-name": "Ellipse 3 copy",
    className: "cls-3",
    d: "M12.972,20.854a8.548,8.548,0,1,1,15.588-4.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.532cc176fe19af3ced09c542dafe732e.svg";
export { ForwardRef as ReactComponent };